import React, { Component, Fragment, useEffect, useState, useCallback } from 'react';
import {
    LocalUser,
    RemoteUser,
    useIsConnected,
    useJoin,
    useLocalMicrophoneTrack,
    usePublish,
    useRemoteUsers,
} from "agora-rtc-react";
import { Button } from 'react-bootstrap';

function AdminTestAgora() {
    const [calling, setCalling] = useState(false);
    const isConnected = useIsConnected(); // Store the user's connection status
    const [appId, setAppId] = useState(process.env.REACT_APP_AGORA_APP_ID);
    const [channel, setChannel] = useState("LearningCenter");
    const [token, setToken] = useState(null);

    useJoin({appid: appId, channel: channel, token: token ? token : null}, calling);

    const [micOn, setMic] = useState(false);
    const { localMicrophoneTrack } = useLocalMicrophoneTrack(micOn);
    usePublish([localMicrophoneTrack]);

    const remoteUsers = useRemoteUsers();

    return (
        <div>
            <div><span>{appId}</span> | <span>{channel}</span></div>
            <div className="room">
                {isConnected ? (
                <div>
                    <div className="user">
                    <LocalUser
                        audioTrack={localMicrophoneTrack}
                        micOn={micOn}
                        cover="https://www.agora.io/en/wp-content/uploads/2022/10/3d-spatial-audio-icon.svg"
                    >
                        <div className="user-name">You</div>
                    </LocalUser>
                    </div>
                    {remoteUsers.map((user) => (
                    <div className="user" key={user.uid}>
                        <RemoteUser cover="https://www.agora.io/en/wp-content/uploads/2022/10/3d-spatial-audio-icon.svg" user={user}>
                        <div className="user-name">{user.uid}</div>
                        </RemoteUser>
                    </div>
                    ))}
                </div>
                ) : (
                <div>
                    <input
                        onChange={e => setAppId(e.target.value)}
                        placeholder="<Your app ID>"
                        value={appId}
                    />
                    <input
                        onChange={e => setChannel(e.target.value)}
                        placeholder="<Your channel Name>"
                        value={channel}
                    />
                    <input
                        onChange={e => setToken(e.target.value)}
                        placeholder="<Your token>"
                        value={token}
                    />

                    <button
                        className={`join-channel ${!appId || !channel ? "disabled" : ""}`}
                        disabled={!appId || !channel}
                        onClick={() => setCalling(true)}
                    >
                        <span>Join Channel</span>
                    </button>
                </div>
                )}
            </div>
            {isConnected && (
                <div className="control">
                <div className="left-control">
                    <button className="btn" onClick={() => setMic(a => !a)}>
                        {micOn ? "MIC OFF" : "MIC ON"}<i className={`i-microphone ${!micOn ? "off" : ""}`} />
                    </button>
                </div>
                <button
                    className={`btn btn-phone ${calling ? "btn-phone-active" : ""}`}
                    onClick={() => setCalling(a => !a)}
                >
                    {calling ? "HANG UP" : "MDI PHONE"}{calling ? <img className="i-phone-hangup" /> : <img className="i-mdi-phone" />}
                </button>
                </div>
            )}
        </div>
    );
}

export default AdminTestAgora;
